import Loader from "react-loader-spinner";

function ChangePin({ handleChange, handleSubmitOtp, isSubmittingOtp }) {
  return (
    <>
      <p className="mb-6 text-center text-muted">
        To update your transaction PIN, kindly enter the OTP sent to your phone
        and the new PIN.
      </p>
      <form className="mb-6" onSubmit={handleSubmitOtp}>
        <div className="form-group mb-5">
          <label className="form-label" htmlFor="pin">
            OTP
          </label>
          <input
            type="password"
            className="form-control text-primary"
            onChange={handleChange}
            name="otp"
            title="Numbers only, e.g. 123456"
            maxLength="6"
            id="otp"
            required
            pattern="[0-9]{6}"
            placeholder="e.g. 123456"
          />
        </div>
        <div className="form-group mb-5">
          <label className="form-label" htmlFor="transaction_pin">
            New Transaction PIN
          </label>
          <input
            type="password"
            className="form-control text-primary"
            onChange={handleChange}
            name="transaction_pin"
            title="Numbers only, e.g. 123456"
            maxLength="6"
            id="transaction_pin"
            required
            pattern="[0-9]{6}"
            placeholder="e.g. 123456"
          />
        </div>
        <div className="form-group mb-5">
          <label className="form-label" htmlFor="confirm_pin">
            Confirm New PIN
          </label>
          <input
            type="password"
            className="form-control text-primary"
            onChange={handleChange}
            name="confirm_transaction_pin"
            title="Numbers only, e.g. 123456"
            maxLength="6"
            id="confirm_pin"
            required
            pattern="[0-9]{6}"
            placeholder="e.g. 123456"
          />
        </div>
        {isSubmittingOtp ? (
          <button className="btn w-100 btn-primary my-2">
            <Loader type="Oval" color="#fff" width={20} height={20} />
          </button>
        ) : (
          <button className="btn w-100 btn-primary my-2" type="submit">
            Submit
          </button>
        )}
      </form>
    </>
  );
}

export default ChangePin;
